import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { contactFaqs } from '../../data/contact';
import { site } from '../../data/site';
export function ContactFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const prefersReducedMotion = useReducedMotion();
  return <Section bordered labelledBy="contact-faq-title" data-id="element-283" data-mp="3oxf5eezatf8o">
      <Container data-id="element-284" data-mp="3oxx19ai1trg2">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-8" data-id="element-285" data-mp="3ovasx8nc37ws">
          <div className="lg:col-span-4" data-id="element-286" data-mp="3sygysf6jax2q">
            <Reveal data-id="element-287" data-mp="1kkwrviv66sm">
              <h2 id="contact-faq-title" className="max-w-[12ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-288" data-mp="1l4htl3t9bav">
                Before you write.
              </h2>
              <p className="mt-6 max-w-[38ch] text-body text-muted" data-id="element-289" data-mp="3584rn6j454d7">
                Four things people ask us first. If yours is not here,{' '}
                <a href={`mailto:${site.email}`} className="text-accent underline decoration-accent/30 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-accent" data-id="element-290" data-mp="121ehya5a04el">
                  just ask
                </a>
                .
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:col-start-6" data-id="element-291" data-mp="ne1mntpo2kb0">
            <ul className="border-t border-hairline" data-id="element-292" data-mp="jadep9x4hmp8">
              {contactFaqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return <li key={faq.question} className="border-b border-hairline" data-id="element-293" data-mp="9cz2xnm59m39" data-mpi={index}>
                    <h3 data-id="element-294" data-mp="9f22ozd3mtl6">
                      <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`contact-faq-panel-${index}`} className="group flex w-full cursor-pointer items-start justify-between gap-8 py-7 text-left" data-id="element-295" data-mp="28qcxzjuggsil">
                        <span className="max-w-[40ch] text-[20px] leading-[1.35] tracking-[-0.02em] text-ink" data-id="element-296" data-mp="3o9arkjxp2xe0">
                          {faq.question}
                        </span>
                        <PlusIcon size={20} aria-hidden="true" className={`mt-1 shrink-0 text-muted transition-transform duration-200 ease-editorial group-hover:text-ink ${isOpen ? 'rotate-45' : ''}`} data-id="element-297" data-mp="ksbth5xf58gj" />
                      </button>
                    </h3>
                    <AnimatePresence initial={false} data-id="element-298" data-mp="2vjlqk6kzixce">
                      {isOpen && <motion.div id={`contact-faq-panel-${index}`} initial={prefersReducedMotion ? false : {
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={prefersReducedMotion ? {
                    opacity: 0
                  } : {
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.23, 1, 0.32, 1]
                  }} className="overflow-hidden" data-id="element-299" data-mp="30iyaaigk7oar">
                          <p className="max-w-measure pb-8 pr-10 text-body text-muted" data-id="element-300" data-mp="zw56bcvhhd0n">
                            {faq.answer}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </Container>
    </Section>;
}